<template>
  <form autocomplete="off">
    <q-toggle
            v-model="details.enabled"
            label="Включен"
    />
    <q-field>
      <q-input
              v-model="details.requisites.merchantAccount"
              stack-label="Идентификатор продавца"
      />
    </q-field>
    <q-field>
      <q-input
              v-model="details.requisites.secretKey"
              stack-label="Секретный ключ"
      />
    </q-field>

    <div class="q-mt-lg row justify-end items-center">
      <div>
        <q-btn
                @click="save()"
                :loading="saving"
                label="Сохранить"
                color="primary"
        />
        <q-btn
                @click="$emit('close')"
                color="primary"
                flat
                label="Закрыть"
        />
      </div>
    </div>
  </form>
</template>

<script>
  import harvester from './mixins/harvester';

  import {
    QField,
    QInput,
    QToggle,
    QBtn,
    QUploader
  } from 'quasar';

  export default {
    name: 'InvoiceMethod',
    components: {
      QField,
      QInput,
      QToggle,
      QBtn,
      QUploader
    },
    mixins: [
      harvester
    ],
    props: {
      provider: Object,
      details: {
        type: Object,
        default () {
          return {
            enabled: false,
            payment_method: 'wayforpay',
            requisites: {
              merchantAccount: '',
              secretKey: '',
            }
          };
        }
      }
    },
    methods: {

    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PaymentMethodEdit/methods/WayforpayMethod.vue